module.exports = __webpack_public_path__ + "static/img/avatar1.569fe15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar1.png
// module id = GTyY
// module chunks = 7